import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showSnackbar } from "../../../api/snackbarSlice";
import { useDispatch } from "react-redux";
import { apiClient } from "../../../utils/axios";
import { isString } from "lodash";
import { useState } from "react";
import { AxiosError } from "axios";

const createSalesInvoice = async ({ payload }) => {
  const profileId = payload?.accounting_supplier_party?.profile_id;
  if (!profileId) {
    throw new Error(
      "Supplier Profile ID is required to create a sales invoice",
    );
  }
  const response = await apiClient.post(
    `/sales-invoices/${profileId}`,
    payload,
  );
  return response.data;
};

const createPurchaseInvoice = async ({ payload }) => {
  const profileId = payload?.accounting_customer_party?.profile_id;
  if (!profileId) {
    throw new Error(
      "Customer Profile ID is required to create a sales invoice",
    );
  }
  const response = await apiClient.post(
    `/purchase-invoices/${profileId}`,
    payload,
  );
  return response.data;
};

export const useCreateInvoiceHandler = ({ onSuccess, isPurchase = false }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: isPurchase ? createPurchaseInvoice : createSalesInvoice,
    onSuccess: (data, variables, context) => {
      dispatch(showSnackbar({ message: "Invoice created successfully." }));
      queryClient.invalidateQueries({ queryKey: ["sales-invoices"] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(
          showSnackbar({
            message: error.response.data.message,
            severity: "error",
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message)
              ? error.message
              : JSON.stringify(error.message),
            severity: "error",
          }),
        );
      }
    },
  });

  const onSubmit = async (payload) => {
    mutation.mutate({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
